/**
 * 校验
 */
export default {
  // 身份证
  isIDCard(str) {
    let value = str.toUpperCase();
    let idCard = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2]\d)|(3[0-1]))\d{3}[xX\d]$/;
    let city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 "
    };
    if (!idCard.test(value)) {
      return false;
    } else if (!city[value.substr(0, 2)]) {
      return false;
    } else {
      //18位身份证需要验证最后一位校验位
      if (value.length === 18) {
        value = value.split("");
        //∑(ai×Wi)(mod 11)
        //加权因子
        let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let sum = 0;
        let ai = 0;
        let wi = 0;
        for (let i = 0; i < 17; i++) {
          ai = value[i];
          wi = factor[i];
          sum += ai * wi;
        }
        //校验位
        let parity = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
        if (parity[sum % 11] !== value[17]) {
          return false;
        }
      }
    }
    return true;
  },
  // 中文名
  isChineseName(str) {
    return /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/.test(str);
  },
  // 日期
  isDate(str) {
    return /^[1-9]\d{3}-((0[1-9])|(1[0-2]))-((0[1-9])|([1-2]\d)|(3[0-1]))$/.test(
      str
    );
  },
  // 座机号码
  isTelephone(str){
    return /^(0[0-9]{2,3}-){1}([2-9][0-9]{6,7})+(-[0-9]{1,4})?$/.test(str);
  },
  // 手机号码
  isMobilePhone(str) {
    return /^1\d{10}$/.test(str);
  },
  // 登录密码
  isPassword(str) {
    // return /^[^\s\u2E80-\u9FFF]{6,20}$/.test(str);
    return /^[\w]{6,20}$/.test(str);
  },
  // 邮箱
  isEmail(str) {
    // eslint-disable-next-line
    return /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/.test(str);
  },
  // 组织机构代码
  isOrganizationCode(str) {
    return /^[A-Z0-9]{8}-[A-Z0-9]$/.test(str.toUpperCase());
  },
  // 营业执照
  isBusinessLicense(str) {
    return /^[A-Z0-9]{15}$/.test(str.toUpperCase());
  },
  // 税务登记证
  isTaxRegistrationCertificate(str) {
    return (
      /^[A-Z0-9]{15}$/.test(str.toUpperCase()) ||
      /^[A-Z0-9]{18}$/.test(str.toUpperCase())
    );
  },
  // 统一社会信用代码
  isUnifiedSocialCreditCode(val) {
    // 18位数字+大写字母
    if (!/^[0-9A-Z]{18}$/.test(val)) {
      return false;
    }
    let Ancode; //统一社会信用代码的每一个值
    let Ancodevalue; //统一社会信用代码每一个值的权重
    let total = 0;
    let weightedfactors = [
      1,
      3,
      9,
      27,
      19,
      26,
      16,
      17,
      20,
      29,
      25,
      13,
      8,
      24,
      10,
      30,
      28
    ]; //加权因子
    let str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
    //不用I、O、S、V、Z
    for (let i = 0; i < val.length - 1; i++) {
      Ancode = val.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      //权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - (total % 31);
    if (logiccheckcode == 31) {
      logiccheckcode = 0;
    }
    let Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
    let Array_Str = Str.split(",");
    logiccheckcode = Array_Str[logiccheckcode];

    let checkcode = val.substring(17, 18);
    if (logiccheckcode != checkcode) {
      return false;
    }
    return true;
  }
};
